module.exports = __webpack_public_path__ + "static/media/ploni-black-aaa.29042687.eot";